/* eslint-disable import-helpers/order-imports */
// Libs
import React, { Suspense, lazy } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { Router, Switch, Route } from "react-router-dom";

import { ConfigProvider, Spin } from "antd";
import { PersistGate } from "redux-persist/integration/react";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { MsalProvider } from "@azure/msal-react";

// Pages (login e reset-password ficam no bundle inicial)
import Private from "./components/private";
import { theme } from "./components/style/theme";
import Login from "./modules/authentication/pages/login";
import ResetPassword from "./modules/authentication/pages/resetPassword";

import "./style.css";
import "antd/dist/antd.variable.min.css";

// store
import { store, persistor } from "./store";

// msal
import { msalInstance } from "./services/msalInstance";
import { authenticateUser } from "./modules/authentication/dataflow/auth-thunk";
import { setLoadingType } from "./components/dataflow/utils-module";

const Campaigns = lazy(() => import("./modules/campaigns/layout"));
const CampaignDetails = lazy(() => import("./modules/campaignsDetails/layout"));
const LayoutContacts = lazy(() => import("./modules/contact/layout"));
const RegisterLead = lazy(() => import("./modules/registerLead/layout"));
const Retention = lazy(() => import("./modules/retention/layout"));
const RetentionDetails = lazy(() => import("./modules/retention/pages/student/layout"));
const LayoutSearchContacts = lazy(() => import("./modules/search/layout"));
const Registration = lazy(() => import("./modules/studentRegistration/layout"));
const ManagementUsers = lazy(() => import("./modules/users/layout"));
const MyActivity = lazy(() => import("./modules/myActivity/layout"));
const InPerson = lazy(() => import("./modules/inPerson/layout"));
const B2BLayout = lazy(() => import("./modules/b2b/layout"));
const Error401 = lazy(() => import("./errors/401"));
const Error404 = lazy(() => import("./errors/404"));

const history = createBrowserHistory();

const GlobalStyle = createGlobalStyle`
  * { box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    overflow-y: hidden;
    background: #F3F3F3;
  }
`;

ConfigProvider.config({
  theme: {
    primaryColor: "#592c82",
  },
});

// Google Analytics desativado temporariamente (componente em ./components/googleanalytics)

function RouteFallback() {
  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        height: "100vh",
        justifyContent: "center",
      }}
    >
      <Spin size="large" />
    </div>
  );
}

async function bootstrap() {
  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise();

  if (response && response.account) {
    msalInstance.setActiveAccount(response.account);
    store.dispatch(setLoadingType({ type: "login" }));
    store.dispatch(authenticateUser(history));
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  render(
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <PersistGate loading={null} persistor={persistor}>
            <Router history={history}>
              <Suspense fallback={<RouteFallback />}>
                <Switch>
                  <Route
                    exact
                    path="/"
                    render={(props) => <Login {...props} />}
                  />
                  <Route
                    exact
                    path="/reset-password"
                    render={(props) => <ResetPassword {...props} />}
                  />
                  <Route path="/contacts/:id">
                    <Private>
                      <LayoutContacts />
                    </Private>
                  </Route>
                <Route path="/lead/:id">
                  <Private>
                    <LayoutContacts />
                  </Private>
                </Route>
                <Route path="/retention/:id">
                  <Private>
                    <LayoutContacts />
                  </Private>
                </Route>
                <Route path="/retencao/:id">
                  <Private>
                    <RetentionDetails />
                  </Private>
                </Route>
                <Route path="/campanhas/:id">
                  <Private>
                    <CampaignDetails />
                  </Private>
                </Route>
                <Route path="/contacts">
                  <Private>
                    <LayoutSearchContacts />
                  </Private>
                </Route>
                <Route path="/usuarios">
                  <Private>
                    <ManagementUsers />
                  </Private>
                </Route>
                <Route path="/retencao">
                  <Private>
                    <Retention />
                  </Private>
                </Route>
                <Route path="/campanhas">
                  <Private>
                    <Campaigns />
                  </Private>
                </Route>
                <Route path="/inscricao">
                  <Private>
                    <Registration />
                  </Private>
                </Route>
                <Route path="/lead">
                  <Private>
                    <Registration />
                  </Private>
                </Route>
                <Route path="/cadastro-de-lead">
                  <Private>
                    <RegisterLead />
                  </Private>
                </Route>
                <Route path="/minhas-atividades">
                  <Private>
                    <MyActivity />
                  </Private>
                </Route>
                <Route path="/presencial">
                  <Private>
                    <InPerson />
                  </Private>
                </Route>
                <Route path="/b2b">
                  <Private>
                    <B2BLayout />
                  </Private>
                </Route>
                <Route exact path="/not-autorized">
                  <Error401 />
                </Route>
                <Route path="*">
                  <Private>
                    <Error404 />
                  </Private>
                </Route>
                </Switch>
              </Suspense>
            </Router>
          </PersistGate>
        </ThemeProvider>
      </Provider>
    </MsalProvider>,
    document.getElementById("root")
  );
}

bootstrap();
